import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@falcon/env';
import {
  DictionaryItem,
  DictionaryParams,
  DictionaryType,
  StatuteDictionaryItem,
} from '@falcon/app/shared/models/dictionary.model';
import { BaseApi } from '@falcon/app/core/api/models/base-api';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService extends BaseApi {
  private http = inject(HttpClient);

  getDictionaryItems<T = string>(
    dictionaryType: DictionaryType,
    params?: DictionaryParams
  ): Observable<DictionaryItem<T>[]> {
    return this.http.get<DictionaryItem<T>[]>(`${environment.apiURL}/${dictionaryType}`, {
      params,
    });
  }

  getPublicDictionaryItems<T = string>(
    dictionaryType: DictionaryType
  ): Observable<DictionaryItem<T>[]> {
    return this.http.get<DictionaryItem<T>[]>(`${environment.publicApiURL}/${dictionaryType}`);
  }

  getTaxLevels<T = string>(isPublic = false, isFrontier = true): Observable<DictionaryItem<T>[]> {
    const api = isPublic ? environment.publicApiURL : environment.apiURL;
    return this.http.get<DictionaryItem<T>[]>(`${api}/taxLevels?isFrontier=${isFrontier}`);
  }

  getCollarTypes<T = string>(isPublic = false, pcCode?: string): Observable<DictionaryItem<T>[]> {
    const api = isPublic ? environment.publicApiURL : environment.apiURL;
    return this.http.get<DictionaryItem<T>[]>(`${api}/collartypes`, {
      params: this.mapParamsToString({ pcs: pcCode }),
    });
  }

  getStatutes(
    isPublic = false,
    pcCode?: string,
    collar?: string
  ): Observable<StatuteDictionaryItem[]> {
    const api = isPublic ? environment.publicApiURL : environment.apiURL;
    return this.http.get<StatuteDictionaryItem[]>(`${api}/statutes`, {
      params: this.mapParamsToString({ pcCode, collar }),
    });
  }
}
